<template>
  <div>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-account-multiple-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Major</span>
      <span v-else>Edit {{ form.name }} </span>
    </h1>
    <h4 v-if="isEdited" class="mb-3 edit-team">
      {{ form.classification.name + ` Classification [ ` + form.name + ` ]` }}
    </h4>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col cols="12" md="3" v-if="!isEdited">
            <form-group name="classification" attribute="fields.classification">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="team_classification"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.classification"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12" md="3" v-if="!isEdited">
            <form-group name="id" attribute="fields.id">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="majorsIndex"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.id"
                ></v-select>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12" :md="isEdited ? 4 : 3"
            ><section class="increment-label">
              <span>Boys Capacity</span>
              <number-input
                center
                v-model="form.boys_capacity"
                :min="1"
                :max="100"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12" :md="isEdited ? 4 : 3"
            ><section class="increment-label">
              <span>Girls Capacity</span>
              <number-input
                center
                v-model="form.girls_capacity"
                :min="1"
                :max="100"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span v-if="isEdited">Save</span
              ><span v-else>Add New Major</span></v-btn
            >
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </div>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    majors: {
      type: Array,
      default: () => {}
    },
    majorObject: {
      type: Object,
      default: () => {}
    },
    major_id: {
      type: Number,
      default: () => {}
    },
    isEdited: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      form: {
        id: "",
        classification: "",
        boys_capacity: 0,
        girls_capacity: 0
      },
      team_classification: [],
      majorsIndex: [],
      loadingData: false
    };
  },
  created() {
    this.indexClassifications();
    this.indexMajors();
  },
  methods: {
    indexClassifications() {
      IndexData({ reqName: `camps/${this.$route.params.id}/classifications` })
        .then(res => {
          const { team_classification } = res.data;
          this.team_classification = team_classification;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexMajors() {
      IndexData({ reqName: `majors` })
        .then(res => {
          const { data } = res.data;
          this.majorsIndex = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createMajor();
      } else {
        this.editMajor();
      }
    },
    showData() {
      // this.form.boys_capacity = { ...this.majorObject.boys_capacity };
      ShowData({
        reqName: `camps/${this.$route.params.id}/majors`,
        id: this.major_id
      })
        .then(res => {
          const { camp_major } = res.data;
          this.form = camp_major;
          this.form.boys_capacity = camp_major.boys_capacity;
        })
        .catch(() => {});
    },
    createMajor() {
      StoreData({
        reqName: `camps/${this.$route.params.id}/majors`,
        data: this.form
      })
        .then(res => {
          this.majors.push(res.data.camp_majors);
          this.$emit("fetchData");
        })
        .catch(() => {})
        .finally(() => {
          this.reset();
        });
    },
    editMajor() {
      const {
        classification,
        actual_count,
        boys_capacity,
        girls_capacity
      } = this.form;

      UpdateData({
        reqName: `camps/${this.$route.params.id}/majors`,
        data: {
          classification,
          actual_count,
          boys_capacity,
          girls_capacity,
          _method: "put"
        },
        id: this.major_id
      })
        .then(res => {
          this.isEdited = false;
          const camp_major = { ...res.data.camp_major };
          this.$emit("fetchData");
          this.$emit("set_edited_major", camp_major);
          this.reset();
        })
        .catch(() => {})
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      (this.form = {
        id: "",
        classification: "",
        boys_capacity: 0,
        girls_capacity: 0
      }),
        this.$store.dispatch("ClearServerErrors");
    }
  },
  watch: {
    isEdited: {
      handler(value) {
        if (value) {
          setTimeout(() => {
            this.showData();
          }, 50);
        }
      },
      immediate: true
    }
  },
  validations: {
    form: {
      classification: {
        required
      },
      id: {
        required
      },
      boys_capacity: {
        required
      },
      girls_capacity: {
        required
      }
    }
  }
};
</script>
